module.exports = __webpack_public_path__ + "static/media/PortfolioWebsiteScreenshot.20568a6d.JPG";